import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import useGetUsers from "@/screens/ChangeLog/hooks/useGetUsers"
import type { RemoveFilterType } from "@/screens/ChangeLog/types"

interface UsersFilterChipProps {
  selectedUserIds?: string[]
  onRemove: (key: RemoveFilterType, value: unknown) => void
}

const UsersFilterChip: React.FC<UsersFilterChipProps> = ({ selectedUserIds, onRemove }) => {
  const { userList } = useGetUsers({ userIds: selectedUserIds })

  const userNames = useMemo(
    () =>
      selectedUserIds
        ?.map((id: string) => {
          return userList.find((user) => user.userId === id)?.name ?? ""
        })
        .filter(Boolean) || [],
    [selectedUserIds, userList]
  )

  return (
    <>
      {userNames.map((name, idx) => (
        <FilterChip
          key={`${name}-${idx}`}
          label={`User: ${name}`}
          onDelete={() => onRemove("userIds", selectedUserIds![idx])}
        />
      ))}
    </>
  )
}

export default UsersFilterChip
